import React from 'react';
import { Card } from '@one-thd/sui-atomic-components';

const AiAssistedSearchBanner = () => {
  return (
    <div data-component="AiAssistedSearchBanner" data-testid="ai-assisted-search-banner">
      <Card />
    </div>
  );
};

AiAssistedSearchBanner.displayName = 'AiAssistedSearchBanner';

export { AiAssistedSearchBanner };
